import TileLayer from 'ol/layer/WebGLTile';
import XYZSource from 'ol/source/XYZ';

export default class Chb2Fairway extends TileLayer {
    static get layerName() {
        return 'chb2-fairway';
    }

    constructor(opt_options) {
        super(Object.assign({
            name: Chb2Fairway.layerName,
            source: new XYZSource({
                crossOrigin: 'anonymous',
                url: '/fairway/api/tileCV/{z}/{x}/{y}',
            })
        }, opt_options));
    }
}
